import React, { useState, useEffect } from 'react';
import { Input, Col, Row, Button, ButtonGroup, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { ImCancelCircle } from 'react-icons/im';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@mui/material/InputLabel';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';
import { MdAttachFile, MdSend } from 'react-icons/md';
import {
    Link,
    useNavigate
} from "react-router-dom";
import { deleteFile, singleFileUploader, getDownloadURLAPI } from '../../utils/FirebaseStorage/FirebaseStorage';
import LoadingModalTransparent from '../../components/modales/loadingModalTransparent';
import Loading from '../../components/modales/loadingModal';


//API Calls
import { functionsHttpsCallable } from '../../utils/FirebaseStorage/firebase';

//API Calls
const { apiEnvioCorreoMasivo, apiListaGrupoCorreos } = require('../../utils/APIs/APISResume')
const grupoCorreos = functionsHttpsCallable('correos_gruposCorreos');
const envioCorreo = functionsHttpsCallable('correos_envioMasivoCorreos');


const MailComposer = () => {
    const navigate = useNavigate();
    const [attachments, setAttachments] = useState([]);
    const [sending, setSending] = useState(false);
    const [loading, setLoading] = useState(false);
    const [time, setTime] = useState(new Date(Date.now()).getTime());
    const [body, setBody] = useState(undefined);
    const [subject, setSubject] = useState(undefined);
    const [opc1, setOpc1] = useState(true);
    const [opc2, setOpc2] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState({});
    const [url, setUrl] = useState();
    const [groupList, setGroupList] = useState([]);

    useEffect(() => {
        async function ListaGrupos() {
            await listGroups()
        }
        ListaGrupos()
    }, [])

    useEffect(() => {
        if (!sending) {
            setBody(undefined);
            setSubject(undefined);
            setAttachments([]);
        }
    }, [sending])

    const listGroups = async () => {
        setLoading(true)
        try {
            const tempArr = []
            const request = await grupoCorreos({ cod_empr: 537 });
            Object.keys(request.data.data).forEach((key) => {
                tempArr.push({ id: key, ...request.data.data[key] })
            })
            setGroupList([...tempArr]);
        }
        catch (error) {
            console.log('error', error)
        }
        setLoading(false)
    }

    const handleAddAttachment = async (file) => {
        let tempArr = [...attachments];
        await singleFileUploader(file, `attachments/${time}`, file.name)
        const downloadUrl = await getDownloadURLAPI(`attachments/${time}`, file.name)
        tempArr.push({ filename: file.name, path: downloadUrl })
        setAttachments(tempArr)
    }

    const handleDelete = async (file) => {
        let tempArr = [...attachments];
        let fileIndex = tempArr.indexOf(file)
        tempArr.splice(fileIndex, 1)
        await deleteFile(`attachments/${time}`, file.filename)
        setAttachments(tempArr)
    }

    const handleSendMail = async () => {
        setSending(true);
        const reqBody = {
            type: opc1 ? 'tradicional' : 'infografia',
            subject: subject,
            attachments: attachments,
            message: body ?? '-',
            to: selectedGroup.correos
        }
        await envioCorreo(reqBody);
        navigate('/home/mail-manager');
        setSending(false);
    }

    const FileUploader = () => {
        return (
            <div className={'FileUploader-style'}>
                <input type="file" id='uploadAssetsInput' onChange={(e) => { handleAddAttachment(e.target.files[0]) }} style={{ display: 'none' }} />
                <IconButton aria-label="Add" onClick={() => { document.getElementById('uploadAssetsInput').click() }}>
                    <MdAttachFile size={24} />
                </IconButton>
            </div>
        )
    }

    const renderBadgeAdjuntos = () => {
        return attachments.map((file, index) => {
            return (
                <div key={`attachment_div_${index}`} className='attachment-pill'>
                    <Button key={`attachment_button_download_${index}`} color="link" onClick={() => console.log('download')}>{file.filename}</Button>
                    <button key={`attachment_button_delete_${index}`} className='attachment-button-detele' onClick={() => handleDelete(file)}><ImCancelCircle color='gray' size={16} /></button>
                </div>
            )
        })
    }

    const renderBody = () => {
        if (opc1) {
            return (<Col lg='12' md='12' xs="12">
                <InputLabel id="body-label">Correo:</InputLabel>
                <Input key='body_Input' type="textarea" name="text" id="body_Input" placeholder='Escribe acá el correo' defaultValue={body !== undefined ? body : ''} onChange={(e) => setBody(e.target.value)} />
            </Col>);
        }
        else if (opc2) {
            return (
                <Col lg='12' md='12' xs="12">
                    {attachments.length > 0 ?
                        <div className='mail-body-area-2'>
                            <img
                                src={attachments[0].path}
                                height="500" />
                            <InputLabel id="link-label">Enlace:</InputLabel>
                            <Input key='body_Input' type="text" name="text" id="body_url_Input" placeholder='Enlace de la imagen' defaultValue={body !== undefined ? body : ''} onChange={(e) => setUrl(e.target.value)} />
                        </div>
                        : <div className='mail-body-area'>
                            <div className='mail-body-area-2'>
                                <FileUploader />
                                <p>Agregar imagen</p>
                            </div>
                        </div>}
                </Col>
            );
        }
    }
    if (loading) { return <div className={"loading-area"}> <Loading /> </div> }
    else {
        return (
            <div>
                <LoadingModalTransparent isOpen={sending} />
                <Breadcrumb>
                    <BreadcrumbItem active>
                        <Link to={"/home/mail-manager"}>
                            Gestor de correos
                        </Link>
                    </BreadcrumbItem>
                    <BreadcrumbItem active>
                        Mail
                    </BreadcrumbItem>
                </Breadcrumb>
                <Row>
                    <Col lg='12' md='12' xs="12">
                        <div className='mail-groupselect-area'>
                            <Autocomplete
                                variant='outlined'
                                required
                                margin="dense"
                                options={groupList}
                                key={`key_centro_costos`}
                                id={`select_centro_costos`}
                                onChange={(event, newValue) => setSelectedGroup((newValue != null) ? { ...newValue } : {})}
                                renderInput={(params) => (
                                    <TextField {...params} variant='outlined' label='Para' margin="normal" />
                                )}
                                getOptionLabel={(option) => option.nombre}
                                renderOption={(option) => (
                                    <React.Fragment>
                                        {option.nombre}
                                    </React.Fragment>
                                )}
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg='12' md='12' xs="12">
                        <TextField
                            required
                            variant='outlined'
                            key={`key_subject`}
                            id={`input_subject`}
                            fullWidth
                            label='Asunto'
                            margin="normal"
                            onChange={(e) => { setSubject(e.target.value) }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col lg='11' md='11' xs="11">
                        <div className='attachment-area'>
                            {renderBadgeAdjuntos()}
                        </div>
                    </Col>
                    <Col lg='1' md='1' xs="1">
                        <div className='add-attachment-area'>
                            {opc1 ? FileUploader() : <br />}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ButtonGroup>
                            <Button
                                onClick={() => {
                                    setOpc1(true);
                                    setOpc2(false)
                                }}
                                color="primary">
                                Tradicional
                            </Button>
                            <Button
                                onClick={() => {
                                    setOpc1(false);
                                    setOpc2(true)
                                }}
                                color="primary">
                                Infografía
                            </Button>
                        </ButtonGroup>
                    </Col>
                </Row>
                <Row>
                    {renderBody()}
                </Row>
                <Row>
                    <Col lg='11' md='11' xs="11">
                        <></>
                    </Col>
                    <Col lg='1' md='1' xs="1">
                        <div className='add-attachment-area'>
                            <div className={'FileUploader-style'}>
                                <IconButton aria-label="Add" onClick={() => { handleSendMail() }}>
                                    <MdSend color='gray' size={24} />
                                </IconButton>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default MailComposer